import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import Lenis from 'lenis'

gsap.registerPlugin(ScrollTrigger)

/**
 * Start Lenis smooth scrolling and wire it into GSAP so ScrollTrigger reads the
 * smoothed scroll position instead of the native one.
 *
 * Two links make the integration work:
 *   1. `lenis.on('scroll', ScrollTrigger.update)` — every smoothed scroll frame
 *      pushes the new position into ScrollTrigger so triggers fire on time.
 *   2. Lenis is advanced from GSAP's own ticker (which wants seconds; Lenis wants
 *      milliseconds) so both run on a single rAF loop and never drift apart.
 *
 * Respects `prefers-reduced-motion`: native scrolling is left untouched and
 * ScrollTrigger falls back to the browser's scroll position on its own.
 *
 * @param {object} [options] - Lenis options (see https://github.com/darkroomengineering/lenis)
 * @returns {Lenis|null} the Lenis instance, or null when reduced motion is on
 */
export function initSmoothScroll(options = {}) {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduceMotion) return null

  const lenis = new Lenis({ lerp: 0.1, ...options })

  lenis.on('scroll', ScrollTrigger.update)

  const raf = (time) => lenis.raf(time * 1000)
  gsap.ticker.add(raf)
  // Lenis runs its own catch-up; GSAP's lag smoothing would fight it.
  gsap.ticker.lagSmoothing(0)

  return lenis
}
